import { cva } from "class-variance-authority";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-glow hover:-translate-y-0.5 transform-smooth",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90 hover:shadow-glow hover:-translate-y-0.5",
        outline:
          "border border-input bg-background hover:bg-accent hover:text-accent-foreground hover:border-primary/30",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80 hover:shadow-card hover:-translate-y-0.5",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        hero: "bg-gradient-hero text-primary-foreground hover:shadow-floating hover:scale-105 transform-bounce font-semibold",
        success: "bg-success text-success-foreground hover:bg-success/90 hover:shadow-glow hover:-translate-y-0.5",
        success2: "bg-success/10 text-success border border-success/20",
        warning: "bg-warning text-warning-foreground hover:bg-warning/90 hover:shadow-glow hover:-translate-y-0.5",
        "step-1": "bg-step-1 text-primary-foreground hover:bg-step-1/90 hover:-translate-y-0.5 transform-smooth",
        "step-2": "bg-step-2 text-primary-foreground hover:bg-step-2/90 hover:-translate-y-0.5 transform-smooth",
        "step-3": "bg-step-3 text-primary-foreground hover:bg-step-3/90 hover:-translate-y-0.5 transform-smooth",
        "step-current": "bg-step-current text-primary-foreground hover:bg-step-current/90 hover:-translate-y-0.5 transform-smooth",
        // Same look as `outline`, recolored to step-current. Touch devices keep a
        // ":hover" state after a tap, so hover is scoped to [@media(hover:hover)]
        // (real pointer devices) rather than plain "hover:", which would otherwise
        // leave touch devices stuck in the hover style after a tap.
        "step-current-outline": "border bg-background border-step-current text-step-current [@media(hover:hover)]:hover:bg-step-current [@media(hover:hover)]:hover:text-accent-foreground [@media(hover:hover)]:hover:border-step-current/30",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
        "default-grow": "text-balance min-h-10 h-auto px-4 py-2",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export { buttonVariants };